module.exports = __webpack_public_path__ + "static/em_capabilities_3_3-539707a2461844e9d2fdf9f1b1e1afaf.png";